let url = "";
let appUrl = "";
let numeroWhatsapp = "5511936206694";

if (process.env.REACT_APP_STAGE === "local") {
    url = "http://localhost:5200";
    appUrl = "http://localhost:3000";
} else if (process.env.REACT_APP_STAGE === "homolog") {
    url = "https://api-dev.appsuria.com.br";
    appUrl = "https://meu-dev.appsuria.com.br";
} else {
    url = "https://api.appsuria.com.br";
    appUrl = "https://meu.appsuria.com.br";
}

export const Constants = {
    url,
    baseUrl: url + "/api/web",
    appUrl,
    numeroWhatsapp,
};
